export const SpinsTableHeader = [
  { title: 'ID', width: 'w-[50px]' },
  { title: 'Дата' },
  { title: 'ID приза' },
  { title: 'Уровень приза' },
  { title: 'ID пользователя' },
];
